import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Alert } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './RegistrationForm.css';
import countryData from '../../country.json'
import moment from "moment";
import TermsAndConditions from "./TermsAndConditions/TermsAndConditions";
import { Dialog, DialogContent, DialogActions } from '@mui/material';
import axios from 'axios';

const RegistrationForm = () => {
  const [formData, setFormData] = useState({
    user_name: '',
    country_code: '',
    phone_no: '',
    email: '',
    country: '',
    created_at: moment().format("YYYY-MM-DD HH:mm:ss")
  });

  const [errors, setErrors] = useState({});
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');
  const [openCondition, setOpenCondition] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    const newFormData = {
      ...formData,
      [name]: value
    };

    if (name === 'country_code' && value) {
      const matchingcountry = countryData.find(country => country.dial_code === value);
      if (matchingcountry) {
        newFormData.country = matchingcountry.name;
      }
    }

    if (name === 'country' && value) {
      const matchingcountry = countryData.find(country => country.name === value);
      if (matchingcountry) {
        newFormData.country_code = matchingcountry.dial_code;
      }
    }

    setFormData(newFormData);

    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: null
      });
    }
  };

  const validateForm = () => {
    let formErrors = {};
    let isValid = true;

    if (!formData.user_name.trim()) {
      formErrors.user_name = 'Name is required';
      isValid = false;
    }

    if (!formData.phone_no.trim()) {
      formErrors.phone_no = 'Phone number is required';
      isValid = false;
    } else if (!/^\d{7,15}$/.test(formData.phone_no.trim())) {
      formErrors.phone_no = 'Please enter a valid phone number (7-15 digits)';
      isValid = false;
    }


    if (!formData.email.trim()) {
      formErrors.email = 'email is required';
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      formErrors.email = 'Please enter a valid email address';
      isValid = false;
    }

    if (!formData.country.trim()) {
      formErrors.country = 'country is required';
      isValid = false;
    }

    

  

    setErrors(formErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      try {
        console.log(formData, "Data for New Registration");

        const response = await axios.post('https://kama-server-registration.xicsolutions.in/users/register', {
          user_name: formData.user_name,
          country_code: formData.country_code,
          phone_no: formData.phone_no,
          email: formData.email,
          country: formData.country
        });

        if (response.data.success) {
          setSubmitSuccess(true);
          setSubmitMessage('Registration successful!');

          console.log("Registered user:", response.data.user_data);
          
          setFormData({
            user_name: '',
            country_code: '',
            phone_no: '',
            email: '',
            country: '',
          });

          setTimeout(() => {
            setSubmitMessage('');
          }, 3000);


        } else {
          setSubmitSuccess(false);
          setSubmitMessage(response.data.message || 'Registration failed. Please try again.');
        }
      } catch (error) {

        setSubmitSuccess(false);
        setSubmitMessage(error.response?.data?.message || 'An error occurred. Please try again later.');
        console.error('Error submitting form:', error);
        setTimeout(() => {
          setSubmitMessage('');
        }, 3000);
      }
    }
  };


  return (
    <Container fluid className="registration-container d-flex align-items-center justify-content-center py-5">
      <Row className="justify-content-center w-100">
        <Col xs={12} sm={10} md={8} lg={6} xl={5}>
          <div className="glass-card">
            <h2 className="text-center mb-4 form-title">User Registration</h2>

            {submitMessage && (
              <Alert variant={submitSuccess ? 'success' : 'danger'} className="mb-4">
                {submitMessage}
              </Alert>
            )}

            <Form onSubmit={handleSubmit} noValidate>

              <Form.Group className="mb-3" controlId="user_name">
                <Form.Label>Full Name</Form.Label>
                <Form.Control
                  type="text"
                  name="user_name"
                  value={formData.user_name}
                  onChange={handleChange}
                  isInvalid={ !!errors.user_name}
                  placeholder="Enter your full name"
                />
                <Form.Control.Feedback type="invalid">
                  {errors.user_name}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-3" controlId="email">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  isInvalid={ !!errors.email}
                  placeholder="Enter your email address"
                />
                <Form.Control.Feedback type="invalid">
                  {errors.email}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-4" controlId="country">
                <Form.Label>Country</Form.Label>
                <Form.Select
                  name="country"
                  value={formData.country}
                  onChange={handleChange}
                  isInvalid={!!errors.country}
                >
                  <option value="">Please select country</option>
                  {countryData.map((country, index) => (
                    <option key={`country-${index}`} value={country.name}>{country.name}</option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {errors.country}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-3" controlId="phone_no">
                <Form.Label>Phone Number</Form.Label>
                <div className="d-flex">
                  <Form.Select
                    className="country-code-select"
                    name="country_code"
                    value={formData.country_code}
                    onChange={handleChange}
                    style={{ flex: '0 0 140px' }}
                  >
                    <option value="">Code</option>
                    {countryData.map((code, index) => (
                      <option key={`code-${index}`} value={code.dial_code}>{code.dial_code}</option>
                    ))}
                  </Form.Select>
                  <Form.Control
                    type="tel"
                    name="phone_no"
                    value={formData.phone_no}
                    onChange={handleChange}
                    isInvalid={ !!errors.phone_no}
                    placeholder="Enter your phone number"
                    className="flex-grow-1"
                  />
                </div>
                <Form.Control.Feedback type="invalid">
                  {errors.phone_no}
                </Form.Control.Feedback>
              </Form.Group>

              <div className="d-grid gap-2 mt-4">
                <Button variant="primary" type="submit" className="submit-btn">
                  Register
                </Button>
              </div>
            </Form>
          </div>
        </Col>
      </Row>

      <Dialog
        open={openCondition}
        onClose={() => setOpenCondition(false)}
        maxWidth='md'
        PaperProps={{
          style: {
            background: 'rgba(15, 15, 15, 0.23)',
            backdropFilter: 'blur(10px)',
            WebkitBackdropFilter: 'blur(10px)',
            borderRadius: '20px',
            border: '1px solid white',
            boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.15)',
            padding: '20px',
            overflow: 'hidden'
          }
        }}
      >
        <DialogContent
          className="reg-form-terms-and-conditions-dialogbox-con"
          style={{
            background: 'transparent',
            padding: '20px',
            color: 'white',
            maxHeight: '80vh',
            overflowY: 'auto',
            '&::-webkit-scrollbar': {
              width: '8px'
            },
            '&::-webkit-scrollbar-track': {
              background: 'rgba(255, 255, 255, 0.1)'
            },
            '&::-webkit-scrollbar-thumb': {
              background: 'rgba(52, 152, 219, 0.5)',
              borderRadius: '4px'
            }
          }}
        >
          <TermsAndConditions />
        </DialogContent>
        <DialogActions className="reg-form-terms-and-conditions-dialogbox-con reg-form-dialog-close">
          <button onClick={() => setOpenCondition(false)} className="reg-registeration-terms-close-btn">Close</button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default RegistrationForm;